module.exports = __webpack_public_path__ + "img/ability-swiper3.1d0bd81b.png";